export default "__VITE_PUBLIC_ASSET__3314d945__"